<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-indent: 00em;">Dedicated to C, J, &amp; L. Your love and support give me life.</p><br/>
<p style="text-indent: 00em;">And to Paul Theroux and Colin Thubron—titans of travel; boundless sources of inspiration and pleasure. Your stories are alive in my imagination and this, too, gives me life.</p><br/>
<p style="text-indent: 00em;">Thank you for each and every one of them.</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?48ed272e